import { Call } from '../../../api/publicCall';

export const getQrCode = async (code: string): Promise<Response> => {
  try {
    const res = await Call('check/getQrCode', 'post', { code: code });

    if (res.ok) {
      return await res;
    } else {
      const errorData = await res.json();
      console.error('Errore API lato server:', errorData);
      return new Response(JSON.stringify(errorData), {
        status: res.status,
        headers: { 'Content-Type': 'application/json' }
      });
    }
  } catch (error) {
    console.error('Errore di rete:', error);
    return new Response(
      JSON.stringify({ success: false, message: 'Errore di rete o server non raggiungibile' }),
      {
        status: 500,
        headers: { 'Content-Type': 'application/json' }
      }
    );
  }
};
